import request from '../utils/request'

export interface SysMenu {
  id: string | number
  parent_id?: string | number | null
  menu_code: string
  title: string
  route_name?: string | null
  path?: string | null
  icon?: string | null
  sort_order?: number
  status?: number
  permission_code?: string | null
  visible?: number
  platform?: string
  remark?: string | null
  children?: SysMenu[]
}

export interface MenuPolicy {
  known_paths: string[]
  visible_paths: string[]
  blocked_paths: string[]
  title_by_path: Record<string, string>
  sort_by_path: Record<string, number>
}

export function getMenuTree() {
  return request.get<SysMenu[]>('/system/menu/tree')
}

export function createMenu(data: Partial<SysMenu>) {
  return request.post<SysMenu>('/system/menu', data)
}

export function updateMenu(id: string | number, data: Partial<SysMenu>) {
  return request.put<SysMenu>(`/system/menu/${id}`, data)
}

export function updateMenuStatus(id: string | number, status: number) {
  return request.patch<boolean>(`/system/menu/${id}/status`, { status })
}

export function sortMenus(data: Array<{ id: string | number; parent_id?: string | number | null; sort_order: number }>) {
  return request.put<boolean>('/system/menu/sort', data)
}

export function getCurrentMenuTree() {
  return request.get<SysMenu[]>('/auth/menu-tree', { silentError: true })
}

export function getCurrentMenuPolicy() {
  return request.get<MenuPolicy>('/auth/menu-policy', { silentError: true })
}
